module.exports = __webpack_public_path__ + "static/media/top02.0f21388d.svg";